import { Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
//import {MomentDateAdapter} from '@angular/material-moment-adapter';

import { ApiDate } from '../models/api_models/apiDate';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';


@Component({
  selector: 'app-form-datepicker',
  templateUrl: './form-datepicker.component.html',
  styleUrls: ['./form-datepicker.component.scss']
})

export class FormDatepickerComponent implements OnInit {
  @Input("dateValue") dateValue:ApiDate;
  @Input("dateLabel") dateLabel:string;
  @Input("hourLabel") hourLabel:string;
  @Output("onApiDateChange")
  onApiDateChange = new EventEmitter<ApiDate>();

  events: string[] = [];
  minDate : Date = new Date();


  constructor() {
    this.dateValue = new ApiDate();
  }

  ngOnInit() {
   
  }
  updateDate(type: string, event: MatDatepickerInputEvent<string>) {
    this.dateValue.date = new Date(event.value);
    this.onApiDateChange.emit(this.dateValue);
    this.dateValue.updateDate();
  }
  updateHour(type: string, event) {
    this.dateValue.hour = event.value;
    this.dateValue.updateDate();
  }
  updateMin(type: string, event) {
    this.dateValue.min = event.value;
    this.dateValue.updateDate();
  }


}
